export default __webpack_public_path__ + "static/media/image.69920a7e.png";